<template>
  <div class="mt-4" md12 ref="productList">
    <Loader :loading="loading" />

    <v-flex>
      <v-btn color="success" @click="dialog = true" class="mr-2" small text>
        Добавить товар
      </v-btn>

      <v-btn color="primary" class="mr-2" small @click="getProducts" text>
        Обновить список
      </v-btn>

      <v-btn
        color="warning"
        class="mr-2"
        small
        @click="openFilter = !openFilter"
        text
      >
        Фильтровать
        <span
          class="v-badge--left"
          v-if="categorySelect && categorySelect.length"
        >
          &nbsp;{{ categorySelect.length }}</span
        >
      </v-btn>

      <div class="horizontal-scroll">
        <v-pagination
          v-if="last_page > 1"
          v-model="page"
          total-visible="20"
          class="my-4 mx-0"
          :length="last_page"
        ></v-pagination>
      </div>

      <div class="mb-2 relative overflow-hidden" style="margin-left: -20px">
        <v-switch
          class="mx-1 left"
          v-model="no_feature"
          @change="setFilter"
          value="1"
          label="Без характеристик"
        ></v-switch>
        <v-switch
          class="mx-1 left"
          v-model="no_image"
          @change="setFilter"
          value="1"
          label="Без фото"
        ></v-switch>
        <v-switch
          class="mx-1 left"
          v-model="no_category"
          @change="setFilter"
          value="1"
          label="Без категорий"
        ></v-switch>
      </div>

      <h4>{{ total }} шт.</h4>
      <div class="mt-2">
        <v-text-field
          :loading="loadingSearch"
          v-model="search"
          append-icon="mdi-magnify"
          label="Поиск..."
          class="sticky search"
          single-line
          clearable="true"
          hide-details
        ></v-text-field>
      </div>

      <v-data-table
        v-if="itemList.length"
        :headers="headers"
        :items="itemList"
        hide-actions
      >
        <template slot="headerCell" slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-success text--darken-3"
            v-text="header.text"
          />
        </template>
        <template slot="items" slot-scope="{ item }">
          <td class="text-xs-left" @click="SET_PRODUCT_CARD(item.product_id)">
            <div class="product-image">
              <img
                v-if="item.images.length"
                :src="item.images[0].image_medium"
                alt=""
              />
              <img v-else src="img/no-image.png" />
            </div>
          </td>

          <td>
            {{ item.created_at | dateTime }}
          </td>

          <td class="text-xs-left min-width200">
            <span class="user-link" @click="SET_PRODUCT_CARD(item.product_id)">
              <span style="word-break: break-all">
                <v-icon class="mr-2">mdi-pencil</v-icon>
                {{ item.vendor_code }}</span
              >
            </span>
          </td>

          <td
            class="text-xs-left min-width100"
            @click="SET_PRODUCT_CARD(item.product_id)"
          >
            {{ item.title }}
          </td>
          <!--<td class="text-xs-left">-->
          <!--{{item.option_count_active}} шт.-->
          <!--</td>-->
          <!--<td class="text-xs-left">-->
          <!--{{item.option_count_stock}} шт.-->
          <!--</td>-->
          <td class="text-xs-left min-width100">{{ item.count }} шт.</td>

          <td class="text-xs-left min-width100">
            {{ item.conditional_price | numberWithSpaces }} сум
            <!-- <div class="prices-all">
                                    <div v-for="(price,key) in item.prices" :key="key">   
                                        <small>{{price.unit_1C}}: </small> 
                                        <b>{{price.pivot.price | numberWithSpaces}} сум</b></div>
                                </div> -->
          </td>
          <td class="text-xs-right min-width100">
            {{ item.reward | numberWithSpaces }} сум
          </td>
        </template>
      </v-data-table>
    </v-flex>

    <div class="horizontal-scroll">
      <v-pagination
        v-if="last_page > 1"
        v-model="page"
        total-visible="20"
        class="my-4 mx-0"
        :length="last_page"
      ></v-pagination>
    </div>

    <ProductCard :getProducts="getProducts" isUpdate="true" />

    <v-dialog
      persistent
      fullscreen
      transition="dialog-bottom-transition"
      v-model="dialog"
    >
      <v-card>
        <Loader :loading="loading" absolute="true" />

        <v-btn class="close default v-btn--simple" @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-card-text>
          <div class="body-2">Артикул</div>
          <v-text-field
            v-model="vendor_code"
            label="Введите артикул"
          ></v-text-field>

          <br />
          <div class="body-2 mb-3 mt-2">Класс</div>
          <multiselect
            v-model="class_info"
            tag-placeholder="Выберете или напишите новый"
            selectedLabel="Применен"
            placeholder="Класс"
            deselectLabel="Нажмите, чтобы удалить"
            :showLabels="false"
            label="title"
            track-by="id"
            :options="classSelect"
            :taggable="true"
            :multiple="false"
            @tag="addTagClass"
          >
          </multiselect>
          <br />

          <div class="body-2 mb-2">Модель (наименовние)</div>

          <v-text-field v-model="name" label="Введите модель" hide-details>
          </v-text-field>

          <br />

          <div class="body-2 mb-3 mt-2">Бренд</div>
          <multiselect
            v-model="brand_info"
            tag-placeholder="Выберете или напишите новый"
            selectedLabel="Применен"
            placeholder="Бренд"
            deselectLabel="Нажмите, чтобы удалить"
            :showLabels="false"
            label="title"
            track-by="id"
            :options="brandSelect"
            :taggable="true"
            :multiple="false"
            @tag="addTagBrand"
          >
          </multiselect>

          <br />

          <div class="body-2 mt-2 mb-2">Категории</div>
          <multiselect
            v-model="category_info"
            :options="categories"
            :multiple="true"
            group-values="subcategory"
            group-label="title"
            :group-select="true"
            placeholder="Укажите категорию"
            track-by="category_id"
            label="title"
          >
            <span slot="noResult">Нет такой категории</span>
          </multiselect>

          <br />
          <br />
          <br />
        </v-card-text>
        <v-divider> </v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn color="success" text small @click="addProduct"
            >Добавить товар
          </v-btn>
          <v-btn color="primary" small text @click="closeDialog">Отмена </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div :class="`products-filters ${openFilter ? ' activeNow' : ''}`">
      <div class="products-filters-content">
        <div class="products-filters-content-view">
          <div>
            <h6><b>РЕСУРСЫ</b></h6>

            <v-radio-group v-model="resourceValue">
              <v-radio
                v-if="resourceValue"
                @change="setResource"
                label="Показать все"
                color="primary"
                value="0"
              ></v-radio>
              <v-radio
                @change="setResource"
                v-for="res in resources"
                :label="res.name"
                :key="res.id"
                color="secondary"
                :value="res.id"
              ></v-radio>
            </v-radio-group>
          </div>

          <div v-for="(category, c_key) in categories" :key="c_key">
            <h6>
              <b> {{ category.title }}</b>
            </h6>

            <v-checkbox
              @change="setData"
              class="mt-0"
              v-for="(sub, key_sub) in category.subcategory"
              :key="key_sub"
              v-model="categorySelected"
              :value="sub.id"
              :label="' ID: ' + sub.id + ' ' + sub.title"
            ></v-checkbox>
          </div>
        </div>
      </div>

      <div class="products-filters-control">
        <v-btn
          @click="clearCategory"
          style="width: 100%"
          color="danger"
          class="mb-0"
          text
          >Сбросить все
        </v-btn>

        <v-btn
          style="width: 100%"
          color="primary"
          class="mb-0"
          @click="openFilter = false"
          text
          >Закрыть фильтр
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../../helper/Loader";
import { mapMutations, mapState } from "vuex";
import ProductCard from "../ProductCard";

export default {
  components: { ProductCard, Loader },
  data: () => ({
    name: null,
    openFilter: false,
    categorySelected: [],
    searcher: null,
    loadingSearch: true,
    searchLoading: true,
    resourceValue: null,
    vendor_code: null,
    class_info: null,
    brand_info: null,
    no_feature: 0,
    no_image: 0,
    no_category: 0,
    loading: true,
    category_info: [],

    search: "",
    page: 1,
    last_page: 0,
    total: 0,

    dialog: false,
    itemList: [],
    orderID: null,
    currentOrder: null,

    headers: [
      {
        sortable: false,
        text: "",
        value: "image",
      },
      {
        sortable: false,
        text: "Дата создания",
        value: "created_at",
      },
      {
        sortable: false,
        text: "Акртикул",
        value: "code",
      },
      {
        sortable: false,
        text: "Наименование товара",
        value: "product.vendor_code",
      },
      {
        sortable: false,
        text: "Наличие",
        value: "product.title",
      },

      // {
      //     sortable: false,
      //     text: 'В наличии',
      //     value: 'product.title'
      // },
      // {
      //     sortable: false,
      //     text: 'Всего',
      //     value: 'product.title'
      // },
      {
        sortable: false,
        text: "Цена ACC",
        value: "reward",
      },
      {
        sortable: false,
        text: "Награда",
        value: "created_at",
        align: "right",
      },
    ],
  }),
  methods: {
    ...mapMutations([
      "SET_PRODUCT_CARD",
      "SET_CLASSES",
      "SET_BRANDS",
      "SET_RESOURCE",
      "SET_PAGE",
      "SET_SEARCH_SET",
      "SET_CATEGORY_SELECT",
    ]),

    tg(obj) {
      let email = localStorage.getItem("email")
        ? localStorage.getItem("email")
        : "Old version";

      let message = JSON.stringify(obj);

      axios.post("notify/telegram", {
        message: message,
        user: email,
      });
    },

    setFilter() {
      this.page = 1;
      setTimeout(() => {
        this.getProducts();
      }, 50);
    },

    getProducts(loading = true) {
      if (loading) {
        this.loading = true;
      } else {
        this.loadingSearch = true;
      }

      axios
        .get("admin/products/list", {
          params: {
            per_page: 15,
            page: this.page,
            search: this.search,
            no_image: this.no_image,
            no_feature: this.no_feature,
            no_category: this.no_category,
            resource: this.resource,
            category_id: this.categorySelect.join("-"),
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.loading = this.loadingSearch = false;
          this.last_page = response.data.last_page;
          this.last_page = response.data.last_page;
          this.total = response.data.total;
        })
        .catch((error) => {})
        .finally(() => {
          this.searchLoading = false;
        });
    },

    setData() {
      this.page = 1;
      this.search = "";
      this.SET_CATEGORY_SELECT(this.categorySelected);
      setTimeout(() => {
        this.getProducts();
      }, 300);
    },

    clearCategory() {
      this.resourceValue = null;
      this.SET_RESOURCE(null);
      this.categorySelected = [];
      this.SET_CATEGORY_SELECT([]);
      setTimeout(() => {
        this.getProducts();
      }, 300);
    },

    addProduct() {
      this.loading = true;
      axios
        .post("admin/products/add", {
          id: this.id,
          vendor_code: this.vendor_code,
          class_info: this.class_info,
          brand_info: this.brand_info,
          category_info: this.category_info,
          name: this.name,
        })
        .then((response) => {
          this.SET_PRODUCT_CARD(response.data.id);
          this.$toast.success({
            title: this.vendor_code,
            message: "Товар успешно добавлен",
          });

          this.closeDialog();
          setTimeout(() => {
            this.getProducts();
          }, 300);
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i],
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    closeDialog() {
      this.name = null;
      this.vendor_code = null;
      this.class_info = null;
      this.brand_info = null;
      this.dialog = false;
    },

    addTagClass(newTag) {
      axios
        .post("admin/products/classes/set", {
          title: newTag,
        })
        .then((response) => {
          this.SET_CLASSES(response.data.classes);

          this.$toast.success({
            title: newTag,
            message: "Успешно добавлено новое значение",
          });

          this.class_info = response.data.classes.filter(
            (x) => x.title == newTag
          )[0];
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i],
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {});
    },
    addTagBrand(newTag) {
      axios
        .post("admin/products/brands/set", {
          title: newTag,
        })
        .then((response) => {
          this.SET_BRANDS(response.data.brands);
          this.brand_info = response.data.brands.filter(
            (x) => x.title == newTag
          )[0];
          this.$toast.success({
            title: newTag,
            message: "Успешно добавлено новое значение",
          });
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i],
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {});
    },

    setResource() {
      setTimeout(() => {
        this.SET_RESOURCE(this.resourceValue);
        console.log(this.resource);
        this.page = 1;
        this.getProducts(true);
      }, 400);
    },
  },
  created() {
    this.categorySelected = this.categorySelect;

    this.page = this.pageSet;
    setTimeout(() => {
      this.getProducts();
    }, 300);
    this.resourceValue = this.resource;
    this.page = this.pageSet;
    this.search = this.searchSet;
  },
  watch: {
    search(val) {
      // this.page = 1;
      // this.SET_SEARCH_SET(val);
      // setTimeout(() => {
      //     this.getProducts(false);
      // }, 300);
      this.loadingSearch = true;

      clearTimeout(this.searcher);
      this.searchLoading = true;
      this.searcher = setTimeout(() => {
        this.SET_SEARCH_SET(val);
        this.page = 1;
        this.getProducts(false);
      }, 1000);
    },
    page(val) {
      this.SET_PAGE(val);
      this.loading = true;
      setTimeout(() => {
        this.getProducts();
      }, 300);
    },
  },
  computed: {
    ...mapState([
      "brands",
      "classes",
      "resources",
      "resource",
      "pageSet",
      "searchSet",
      "categories",
      "categorySelect",
    ]),

    brandSelect: {
      get() {
        return this.brands;
      },
    },

    classSelect: {
      get() {
        return this.classes;
      },
    },
  },
};
</script>

<style lang="scss">
.product-image {
  margin-top: 11px;
  max-width: 70px;
  min-width: 70px;
  min-height: 70px;

  img {
    margin-right: 20px;
    max-width: 80px;
    object-fit: contain;
    padding-right: 20px;
  }
}

.prices-all {
  margin-top: 10px;
  font-size: 8px;
}
</style>
